<template>
  <div class="task-manager-1 px-md-4 pt-md-4 pb-md-2">
    <!-- create Tasks -->
    <div class="d-flex flex-column flex-lg-row justify-content-between">
      <h4 class="py-3 py-md-0 mx-3 mx-md-0">{{ subHeading }}</h4>
      <!-- <div class="mr-md-3 form-group form-field-style-1">
          <label class="checkbox-main"> {{$t('global.todayCheckBox')}}
            <input type="radio" value="day" v-model="type">
            <span class="checkmark"></span>
          </label>
        </div>
        <div class="form-group form-field-style-2">
          <label class="checkbox-main">{{$t('global.weekCheckBox')}}
            <input type="radio" value="week" v-model="type">
            <span class="checkmark"></span>
          </label>
        </div> -->

      <div class="form-group form-medical-field-style-4 search-icon">
        <span class="search-icon-item">
          <i class="fa fa-search" aria-hidden="true"></i>
        </span>
        <input
          class="form-control"
          :placeholder="$t('global.search')"
          v-model="search"
          type="text"
        />
      </div>
      <div class="ml-md-3 form-group form-field-style-5">
        <button class="create-new-btn" @click="showModal(false)">
          {{ $t("global.createNew") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    subHeading: {
      type: String,
    },
    modalName: {
      type: String,
    },
  },

  data() {
    return {
      search: '',
    };
  },

  methods: {
    showModal(flag) {
      this.$modal.show(this.modalName);
    },

    searchByName() {
      this.$emit('name', this.search);
    },
  },

  watch: {
    search: {
      handler: 'searchByName',
    },
  },
};
</script>
<style lang="scss">
.checkbox-main {
  display: block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 5px;
    left: 0;
    height: 15px;
    width: 15px;
    background-color: transparent;
    border: 2px solid #4f78e2;
    border-radius: 2px;
    &:after {
      content: "";
      position: absolute;
      display: none;
    }
    &:after {
      left: 4px;
      top: 1;
      width: 4px;
      height: 8px;
      border: solid #fff;
      border-width: 0 1px 1px 0;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
  &:hover {
    input ~ .checkmark {
      background-color: transparent;
    }
  }
  input:checked ~ .checkmark {
    background-color: #4f78e2;
    &:after {
      display: block;
    }
  }
}
.form-medical-field-style-4 {
  width: 50%;
  @media (min-width: 1090px) and (max-width: 1292px) {
    width: 200px;
  }
  @media (min-width: 993px) and (max-width: 1090px) {
    width: 160px;
  }
  input {
    padding-left: 40px;
    text-align: left;
  }
}
.form-field-style-5 {
  width: 131px;
  .create-new-btn {
    background-color: #4f78e2;
    width: 100%;
    height: 35px;
    border: none;
    border-radius: 3px;
    color: #fff;
    font-family: "SF-Pro-Text";
    font-weight: 500;
    &:focus {
      outline: none;
    }
  }
}
</style>
